module.exports = __webpack_public_path__ + "static/media/retts_logo_small.31f9959a.png";